export default function MatrixBannerField(content, i) {
    if (!content?.content) {
        return <></>
    }

    return (
        <section key={i}>
            <img src={content?.content?.image_1?.url} width={'100%'} height={350}
                 className={'my-10 md:my-20 w-full object-cover max-h-[350px]'}/>
        </section>
    );
}
